import { render } from "./LawForm.vue?vue&type=template&id=3be3952a&scoped=true&ts=true"
import script from "./LawForm.ts?vue&type=script&lang=ts"
export * from "./LawForm.ts?vue&type=script&lang=ts"

import "./LawForm.scss?vue&type=style&index=0&id=3be3952a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be3952a"]])

export default __exports__